import { Box, Skeleton, Typography } from '@compass/core';
import { PieChart, Export, Series, Label, Connector, Legend } from 'devextreme-react/pie-chart';
import { useParticipantsData } from '../contexts/ParticipantsDataContext';
import { DashboardCard } from '../components/DashboardCard';
import { ParticipantsFilterControls } from './ParticipantsFilterControls';
import { ParticipantStatusChartValue } from '../types/ParticipantStatusData';

interface ChartLabelArg {
    value: number;
    point?: {
        data?: ParticipantStatusChartValue;
    };
}

const ParticipantsChartContent = () => {
    const { chartData, loading, error, data } = useParticipantsData();

    if (loading) {
        return <Skeleton variant="rounded" height={300} />;
    }

    if (error) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    if (!chartData.length) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                <Typography variant="body2" color="text.secondary">
                    No participants found for selected filters
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <PieChart
                    id="participants-pie-chart"
                    dataSource={chartData}
                    palette="Bright"
                    width="100%"
                    height={300}
                >
                    <Series argumentField="label" valueField="value">
                        <Label 
                            visible={true}
                            customizeText={(arg: ChartLabelArg) => {
                                const count = arg.point?.data?.count ?? 0;
                                return `${count} (${arg.value.toFixed(1)}%)`;
                            }}
                        >
                            <Connector visible={true} width={1} />
                        </Label>
                    </Series>
                    <Legend
                        visible={true}
                        horizontalAlignment="center"
                        verticalAlignment="bottom"
                    />
                    <Export enabled={true} />
                </PieChart>
            </Box>
            {data && (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="caption" color="text.secondary">
                        Total Participants: {data.totalParticipants}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export const ParticipantsChartCard = () => (
    <DashboardCard title="Participants Assisted">
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <ParticipantsFilterControls />
            <ParticipantsChartContent />
        </Box>
    </DashboardCard>
);